import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { DialogActions, DialogContent } from '@mui/material';
import { getData } from 'country-list';
import Button from '@components/core/buttons';
import { CustomDialog, DialogTitle } from '@components/core/dialog';
import ExpandableGridV2 from '@components/core/expandable/grid-v2';
import { useTranslation } from '@hooks/index';

interface ICountriesProps {
    onClose: () => void;
}

const Index = ({ onClose }: ICountriesProps) => {
    const { t } = useTranslation();

    return (
        <CustomDialog onClose={onClose} maxWidth="md" scroll="paper" open>
            <DialogTitle id="import-modal-title">
                {t('ra:countryList')}
                <FontAwesomeIcon
                    icon={['fal', 'times']}
                    className="fa-lg close-icon-cv"
                    data-testid="close-dialog"
                    onClick={onClose}
                />
            </DialogTitle>
            <DialogContent style={{ paddingLeft: 15, paddingRight: 15 }}>
                <ExpandableGridV2
                    customKey="countries-list-grid"
                    id="countries-list-grid"
                    key="countries-list-grid"
                    maxHeight={500}
                    items={getData()
                        .sort((a, b) => a.name.localeCompare(b.name))
                        .map((countryObject: { name: string }) => ({
                            name: countryObject.name,
                        }))}
                    groupable={false}
                    scrollable="scrollable"
                    reorderable
                    pageable={false}
                    resizable={false}
                    showPager={false}
                    hideCheckbox
                    hideExpand
                    columns={[
                        {
                            field: 'name',
                            label: t('ra:countryName'),
                            width: 550,
                        },
                    ]}
                    showFirstColumn
                />
            </DialogContent>
            <DialogActions>
                <Button
                    text="close"
                    id="country-list-dialog-close"
                    data-testid="country-list-dialog-close"
                    onClick={onClose}
                />
            </DialogActions>
        </CustomDialog>
    );
};

export default Index;
